import { jsx as _jsx } from "react/jsx-runtime";
import { BaseModal } from './BaseModal';
export const ContentModal = ({ footer, children, ...baseProps }) => {
    return (_jsx(BaseModal, { ...baseProps, footer: footer, contentClassName: baseProps.contentClassName ?? 'p-6', children: children }));
};
//# sourceMappingURL=ContentModal.js.map